//--------------------------------------------------------------------------------
//
// Client side px support
//
//--------------------------------------------------------------------------------

let stripe   = null;
let elements = null;

export function pxInit()
{
    if (!Stripe) {
        console.error("Stripe not found");
        return;
    }
    stripe = Stripe(process.env.PX_PUBLIC_KEY);
}

//--------------------------------------------------------------------------------
//
// SHOW
//
//--------------------------------------------------------------------------------

export function onPxShow(app) {
    return function(payIntentID) {
        if (!stripe) {
            console.error("onPxShow stripe not initialized");
            return;
        }

        requestAnimationFrame(function() {
            const options = {
                clientSecret: payIntentID,
                appearance: {
                    theme:  "night",
                    labels: "floating",
                },
            };

            elements = stripe.elements(options);
            const pxElement  = elements.create("payment");
            pxElement.mount("#payment-element");
        });
    }
}

//--------------------------------------------------------------------------------
//
// SUBMIT
//
//--------------------------------------------------------------------------------

export function onPxSubmit(app) {
    return async function(returnURL) {
        if (!elements) {
            console.error("onPxSubmit elements not initialized");
            return;
        }

        const { error } = await stripe.confirmSetup({
            elements,
            confirmParams: {
                return_url: returnURL,
            },
        });

        if (error) {
            console.log("!!! onPxSubmit confirm response err:", error);
            const messageContainer = document.querySelector("#error-message");
            messageContainer.textContent = error.message;
        } else {
            console.log("--- onPxSubmit confirmed.");
        }
    }
}

//--------------------------------------------------------------------------------
//
// DONE
//
//--------------------------------------------------------------------------------

export function onPxDone(app) {
    return function() {
        elements = null;
    }
}

//--------------------------------------------------------------------------------

